module.exports = __webpack_public_path__ + "static/img/fz_lcb_ys.77d4590.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_lcb_ys.png
// module id = EHLP
// module chunks = 0